export default {
  cnCode: "CN Code",
  factorValue: "Emission Factor",
  unit: "Unit",
  coefficient: "Process Coefficient",
  description: "Description",
  createdAt: "Created At",
  updatedAt: "Updated At",
  action: "Action",
  error: "Error",
  search: "Search",
  add: "Add Factor",
  edit: "Edit",
  template: "Template",
  csvTemplate: "CSV Template",
  xlsxTemplate: "XLSX Template",
  deleteConfirm: "Are you sure to delete this factor?",
  deleteConfirmBatch: "Are you sure to delete these factors?",
  import: "Import Factors",
  export: "Export Factors",
  close: "Close",
  reset: "Re-import",
  resetConfirm: "Are you sure to re-import?",
  ok: "OK",
  clearInvalid: "Clear Invalid Data",
  showErrorRows: "Show Error Data",
  hideErrorRows: "Hide Error Data",
  placeholder: {
    cnCode: "Enter CN Code (e.g., '24')",
    factorValue: "Enter Emission Factor",
    coefficient: "Enter Process Coefficient (0-1)",
    description: "Enter Description (e.g., 'Used for low-carbon steel production')",
    unit: "Select unit",
  },
  cnCodeRequired: "Please enter CN Code",
  cnCodeMaxLength: "CN Code must not exceed 20 characters",
  cnCodeFormat: "CN Code can only contain letters, numbers, and underscores",
  cnCodeExample: "Example: Steel CN Code '24', Emission Factor 1.5, Process Coefficient 0.8",
  factorValueRequired: "Please enter Emission Factor",
  factorValueMin: "Emission Factor must be greater than 0",
  factorValueUnit: "Unit is kg CO2e/kg, convert cement to this unit",
  coefficientRequired: "Please enter Process Coefficient",
  coefficientRange: "Process Coefficient must be between 0 and 1",
  descriptionMaxLength: "Description must not exceed 255 characters",
  fetchError: "Failed to fetch factors",
  addSuccess: "Factor added successfully",
  addError: "Failed to add factor",
  editSuccess: "Factor updated successfully",
  editError: "Failed to update factor",
  deleteSuccess: "Factor deleted successfully",
  deleteError: "Failed to delete factor",
  exportSuccess: "Export successful",
  exportError: "Failed to export factors",
  uploadFormatError: "Only CSV or XLSX files are supported",
  headerInvalid: "Invalid file header, expected: cn_code,factor_value,coefficient,description",
  headerSkipped: "Header row skipped",
  importLimitExceeded: "Import data exceeds limit (max {max} valid rows)",
  noValidData: "No valid factor data",
  parseError: "Failed to parse file",
  importError: "Failed to import factors",
  importSuccess: "Successfully imported {count} factors",
  clearInvalidSuccess: "Cleared {count} invalid data rows",
  noInvalidData: "No invalid data to clear",
  uploadText: "Click or drag file to this area to upload",
  uploadHint: "Supports CSV and XLSX formats",
  unitRequired: "Please select a unit",
  unitInvalid: "Invalid unit, only kg CO2e/kg or kg CO2e/tonne supported",
  batchDelete: "Batch Delete",
  batchDeleteSuccess: "Successfully deleted {count} factors",
  batchDeleteError: "Failed to batch delete factors",
};
